import { _t } from "../../../app/i18n/i18n";

export const getIdToName = (id) => {
  const nameMap = {
    1: _t("Prev Day"),
    2: _t("Prev Week"),
    3: _t("Prev Month"),
    4: _t("Prev Quarter"),
  };
  return nameMap[id] || "";
};

export const mockRequestBody = {
  language: [1],
  facets: {
    txSubcategory: ["Anchor Report", "Sector Update"],
  },
};
